export default __webpack_public_path__ + "static/media/curable-preexisting-conditions-coverage-after-12-months.639706f5.pdf";